export default "/static/media/energy.0f0e6242.css";